var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTruckGone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "truck_gone",
    width: 36,
    height: 36,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "truck_gone",
    d: "m 2.766449,20 h 8 v 2 h -8 z M 1,17 h 8 v 2 H 1 Z m 2,-3 h 8 v 2 H 3 Z m 29,0 H 29 V 10 H 15 c -1.1,0 -2,0.9 -2,2 v 11 h 2 c 0,1.66 1.34,3 3,3 1.66,0 3,-1.34 3,-3 h 6 c 0,1.66 1.34,3 3,3 1.66,0 3,-1.34 3,-3 h 2 V 18 Z M 18,24.5 c -0.83,0 -1.5,-0.67 -1.5,-1.5 0,-0.83 0.67,-1.5 1.5,-1.5 0.83,0 1.5,0.67 1.5,1.5 0,0.83 -0.67,1.5 -1.5,1.5 z m 13.5,-9 1.96,2.5 H 29 v -2.5 z m -1.5,9 c -0.83,0 -1.5,-0.67 -1.5,-1.5 0,-0.83 0.67,-1.5 1.5,-1.5 0.83,0 1.5,0.67 1.5,1.5 0,0.83 -0.67,1.5 -1.5,1.5 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckGone);
export default __webpack_public_path__ + "static/media/truck_gone.84c64f8874218b691bf33d9406bf29ea.svg";
export { ForwardRef as ReactComponent };